import { AssessmentProgram } from "@lib/ShiOneClient";
import { ShiOnePermission } from "../../../../auth/authorizationTypes";

export const CACHE_KEY_ASSESSMENTS = "assessments";
export const CACHE_KEY_HARVEY_BALL = "assessments-harvey-ball";

export const CACHE_KEY_ASSESSMENTS_OVERVIEW = "assessments-overview";
export const CACHE_KEY_ASSESSMENTS_MATURITY_CHART =
  "assessments-maturity-chart";
export const CACHE_KEY_ASSESSMENTS_MATURITY_COMPARISON =
  "assessments-maturity-comparison";
export const CACHE_KEY_ASSESSMENTS_RECOMMENDATIONS = "assessments-recs";
export const CACHE_KEY_ASSESSMENTS_PLATFORM_INSIGHTS =
  "assessments-platform-insights";
export const CACHE_KEY_ASSESSMENTS_CAPABILITY_INSIGHTS =
  "assessments-capability-insights";
export const CACHE_KEY_ASSESSMENTS_CAPABILITY_CHANGES =
  "assessments-capability-changes";
export const CACHE_KEY_ASSESSMENTS_MATURITY_SCORE_AVERAGES =
  "assessments-maturity-score-averages";

export const assessmentPrograms = {
  spr: "security-posture-review",
  sprV2: "security-posture-review-v2",
  aiReadiness: "ai-readiness",
  dopr: "dev-ops-posture-review",
  awsMaturity: "aws-maturity-review",
  tpx: "tpx",
  cloudMatrix: "cloud-matrix",
  microsoftInsights: "microsoft-insights"
};

export const assessmentStatuses = {
  published: "Published",
  complete: "Complete",
  inProgress: "In Progress",
  readyForReview: "Ready for Review",
  outdatedVersion: "Outdated Version",
  processing: "Processing",
} as const;

export enum assessmentTabIds {
  overview = "overview",
  maturityChart = "maturity-chart",
  recommendations = "recommendations",
  platformInsights = "platform-insights",
  capabilityInsights = "capability-insights",
  capabilityChanges = "capability-changes",
}

export enum assessmentTabViewMode {
  table = "Table View",
  card = "Card View",
  list = "List View",
}

export const sprCategories: { [key: string]: string } = {
  applications: "Applications",
  cloud: "Cloud",
  dataSecurity: "Data Security",
  endUser: "End User",
  governanceCompliance: "Governance & Compliance",
  identity: "Identity",
  monitoringAlerting: "Monitoring & Alerting",
  network: "Network",
  operations: "Operations",
};

export const aiReadiness: { [key: string]: string } = {
  infrastructure: "Infrastructure",
  business: "Business",
  data: "Data",
  security: "Security",
};

export const capabilitiesPriorities = {
  doNow: "Do Now",
  doLater: "Do Later",
  backlog: "Backlog",
  unknown: "Unknown",
  shortTermV2: "Short Term",
  mediumTermV2: "Medium Term",
  longTermV2: "Long Term",
};

export const capabilitiesImpact = {
  lowImpact: "Low Impact",
  highImpact: "High Impact",
  lowImpactV2: "Low",
  mediumImpactV2: "Medium",
  highImpactV2: "High",
};

export const sortedPriorities: { [key: string]: number } = {
  "Do Now": 1,
  "Do Later": 2,
  Backlog: 3,
  Unknown: 4,
};

export const sortedSPRv2Priorities: { [key: string]: number } = {
  "Short Term": 1,
  "Medium Term": 2,
  "Long Term": 3,
  Unknown: 4,
};

export const maturityLevels: { [key: string]: string } = {
  optimized: "Optimized",
  operational: "Operational",
  installed: "Installed",
  functional: "Functional",
  evaluating: "Evaluating",
  gap: "Gap",
  unknown: "Unknown",
};

export const timePeriodPriority: Map<string, string> = new Map<string, string>([
  // AI Readiness / SPR
  ["Do Now", "Within 12 months"],
  ["Do Later", "After 12 months"],
  ["Backlog", ""],
  // TPX sections
  ["Immediate Impact", "2-6 weeks"],
  ["Build & Scale", "6-16 weeks+"],
  ["Enablement & Change Management", ""],
]);

export const assessmentPermissions = new Map<
  AssessmentProgram,
  ShiOnePermission
>([
  [AssessmentProgram.Tpx, ShiOnePermission.tpxAssessmentRead],
  [AssessmentProgram.AiReadiness, ShiOnePermission.aiReadinessRead],
  [
    AssessmentProgram.SecurityPostureReview,
    ShiOnePermission.securityPostureReviewRead,
  ],
  [
    AssessmentProgram.SecurityPostureReviewV2,
    ShiOnePermission.securityPostureReviewRead,
  ],
  [
    AssessmentProgram.DevOpsPostureReview,
    ShiOnePermission.devOpsPostureReviewRead,
  ],
  [AssessmentProgram.AwsMaturity, ShiOnePermission.awsMaturityRead],
  [AssessmentProgram.CloudMatrix, ShiOnePermission.cloudMatrixRead],
  [AssessmentProgram.MicrosoftInsights, ShiOnePermission.microsoftInsightsRead],
]);
